import { AxiosResponse } from 'axios';
import encoding from 'encoding-japanese';

export const sleep = async (second: number): Promise<void> => {
  await new Promise((resolve) => setTimeout(resolve, second));
};

export const ommisionText = (text: string, length: number): string => {
  if (text.length <= length) {
    return text;
  }
  return text.substring(0, length) + '...';
};

/**
 * @param T - オブジェクトの配列
 * @param K - オブジェクトのkey
 * @return オブジェクトを一意にした配列を返す
 */
export const uniqueObjInArray = <T>(array: T[], key: keyof T): T[] => {
  return Array.from(
    new Map(array.map((value) => [value[key], value])).values()
  );
};

/**
 * @param T - number、stringの配列
 * @return 一意にした配列を返す
 */
export const unique = <T>(array: T[]): T[] => {
  return Array.from(new Set(array));
};

export const nullToEmptyString = (value: string | null): string => {
  return value === null ? '' : value;
};

export const emptyStringToNull = (value: string): string | null => {
  return value === '' ? null : value;
};

export const nonNullableStr = (value: string | number | null): string => {
  if (typeof value === 'number') {
    return value.toString();
  }
  return value !== null ? value : '';
};

const downloadFile = ({
  data,
  type,
  fileName,
}: {
  data: BlobPart[];
  type: string;
  fileName: string;
}): void => {
  const blob = new Blob(data, {
    type,
  });
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = fileName;
  a.click();
  URL.revokeObjectURL(url);
};

export const downloadFileFromResponse = (response: AxiosResponse): void => {
  downloadFile({
    data: [response.data],
    type: response.headers['content-type'],
    fileName: getFileNameFromContentDisposition(response),
  });
};

export const getFileNameFromContentDisposition = (
  response: AxiosResponse
): string => {
  const contentDisposition = response.headers['content-disposition'];
  const fileName = contentDisposition
    .split('filename=')[1]
    .split(';')[0]
    .replace(/['"]/g, '');
  return fileName;
};

export const downloadFileFromResponseWithName = (
  response: AxiosResponse,
  fileName: string,
  userOs: string
): void => {
  let data;

  if (userOs === 'Windows') {
    const utf8Array = new TextEncoder().encode(response.data);
    const sjisArray = encoding.convert(utf8Array, { to: 'SJIS', from: 'UTF8' });
    data = new Uint8Array(sjisArray);
  } else {
    data = new TextEncoder().encode(response.data);
  }

  const blob = new Blob([data], {
    type:
      response.headers['content-type'] ||
      'text/csv; charset=' + (userOs === 'Windows' ? 'shift_jis' : 'utf-8'),
  });

  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = fileName;
  a.click();
  URL.revokeObjectURL(url);
};
